import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { ICRUDOptions } from '@phx-erp/shared';
import { BaseListService } from "../../../@core/services/base-list.service";
import { SystemService } from "../../../@core/services/system.service";
import { ADD_DATA_PROTECTION_ASSETS, DELETE_DATA_PROTECTION, GET_DATA_PROTECTION, GET_DATA_PROTECTIONS, SAVE_DATA_PROTECTION } from "../../../data/definitions/data-protection.definition";
import { BaseDataService } from "../../../data/services/base-data.service";
import { DataService } from "../../../data/services/data.service";
import { AddDataProtectionAssetsMutation, AddDataProtectionAssetsMutationVariables, DataProtection, DataProtectionInput, DeleteDataProtectionMutation, DeleteDataProtectionMutationVariables, DeletionResponse, GetDataProtectionQuery, GetDataProtectionQueryVariables, GetDataProtectionsQuery, GetDataProtectionsQueryVariables, SaveDataProtectionMutation, SaveDataProtectionMutationVariables, SearchInput } from "../../../generated/generated-types";

@Injectable({
  providedIn: 'root'
})
export class DataProtectionService extends BaseListService<DataProtection> {

  constructor(private dataService: DataService,
    private baseDataService: BaseDataService,
    private systemService: SystemService) {
    super();
  }
  //#region implementation
  getItems(searchInput?: SearchInput, o?: ICRUDOptions) {

    let fragment = GET_DATA_PROTECTIONS;

    if (o?.currentColumnConfig) {
      this.onlyKeepSelectedGraphQLNodesNew(fragment, o.currentColumnConfig.baseView, o.currentColumnConfig.columns);
    }

    return this.baseDataService.query<GetDataProtectionsQuery, GetDataProtectionsQueryVariables>(
      fragment, {
      input: searchInput as any
    });
  }

  getItem(id: string) {

    return this.baseDataService.query<GetDataProtectionQuery, GetDataProtectionQueryVariables>(
      GET_DATA_PROTECTION, {
      id: id
    });
  }

  getItemStream(id: string) {
    return this.getItem(id).mapStream(x => x.getDataProtection);
  }

  async getItemData(id: string): Promise<DataProtection> {
    let l = await lastValueFrom(this.getItem(id).single$);
    return l.getDataProtection as DataProtection;
  }

  async deleteItem(id: string): Promise<DeletionResponse> {
    let res = await lastValueFrom(this.baseDataService.mutate<DeleteDataProtectionMutation, DeleteDataProtectionMutationVariables>(
      DELETE_DATA_PROTECTION, {
      id: id
    }));

    return res.deleteDataProtection
  }

  async saveItem(item: DataProtection | DataProtectionInput) {

    let validated = await this.systemService.validateObject<DataProtectionInput>(
      item, "DataProtectionInput");

    let saved = await lastValueFrom(this.baseDataService.mutate<SaveDataProtectionMutation, SaveDataProtectionMutationVariables>(
      SAVE_DATA_PROTECTION, {
      input: validated
    }));

    return saved.saveDataProtection as DataProtection;
  }

  async addAssets(dataProtectionId: string, assetIds: string[]): Promise<boolean> {
    return lastValueFrom(this.baseDataService.mutate<AddDataProtectionAssetsMutation, AddDataProtectionAssetsMutationVariables>(
      ADD_DATA_PROTECTION_ASSETS, {
      id: dataProtectionId,
      assetIds: assetIds
    }, null, [{
      query: GET_DATA_PROTECTION,
      variables: {
        id: dataProtectionId
      }
    }]
    )).then((res) => { return res.addDataProtectionAssets; });
  }
  //#endregion

}
